import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

interface Props {
  color: string;
  isAnimation: boolean;
}
export default function Microphone({ color, isAnimation }: Props) {
  return (
    <SvgIcon
      style={{
        height: '35px',
        width: '23px',
        animation: isAnimation ? 'pulsing 3s infinite ease-out' : '',
      }}
      viewBox={'0 0 23 35'}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23"
        height="35"
        viewBox="0 0 23 35"
        fill="none"
      >
        <path
          d="M11.5 21.6673C13.1397 21.6673 14.7124 21.0159 15.8719 19.8564C17.0314 18.6969 17.6827 17.1243 17.6827 15.4846V7.24127C17.6946 6.42187 17.5436 5.60827 17.2382 4.8478C16.9329 4.08734 16.4794 3.39512 15.9041 2.81147C15.3289 2.22783 14.6433 1.76434 13.8873 1.448C13.1314 1.13165 12.3201 0.96875 11.5006 0.96875C10.6811 0.96875 9.86984 1.13165 9.11388 1.448C8.35792 1.76434 7.67232 2.22783 7.09707 2.81147C6.52183 3.39512 6.06846 4.08734 5.76311 4.8478C5.45776 5.60827 5.30658 6.42187 5.31846 7.24127V15.4793C5.31778 16.2916 5.47722 17.096 5.78755 17.8467C6.09788 18.5973 6.55301 19.2795 7.12707 19.8541C7.70112 20.4288 8.38276 20.8847 9.13308 21.1958C9.8834 21.5069 10.6877 21.6672 11.5 21.6673ZM22.8347 16.0123C22.8347 16.0123 22.8347 16.0123 22.8347 16.0045C22.8347 15.5946 22.6718 15.2014 22.3819 14.9115C22.092 14.6217 21.6989 14.4589 21.289 14.4589C20.8791 14.4589 20.4858 14.6217 20.1959 14.9115C19.9061 15.2014 19.7433 15.5946 19.7433 16.0045C19.7433 18.1908 18.8748 20.2875 17.3289 21.8334C15.7829 23.3793 13.6862 24.2478 11.5 24.2478C9.31371 24.2478 7.21699 23.3793 5.67107 21.8334C4.12515 20.2875 3.25674 18.1908 3.25674 16.0045C3.25674 15.5946 3.09387 15.2014 2.80399 14.9115C2.51412 14.6217 2.12087 14.4589 1.71093 14.4589C1.30098 14.4589 0.907895 14.6217 0.61802 14.9115C0.328146 15.2014 0.165274 15.5946 0.165274 16.0045C0.164961 16.0071 0.164961 16.0097 0.165274 16.0123C0.165579 18.7482 1.15753 21.3913 2.95745 23.4518C4.75737 25.5122 7.24326 26.8504 9.95431 27.2184V30.9402H4.8024C4.39245 30.9402 3.9992 31.1031 3.70933 31.393C3.41945 31.6829 3.25674 32.0759 3.25674 32.4859C3.25674 32.8958 3.41945 33.289 3.70933 33.5789C3.9992 33.8688 4.39245 34.0316 4.8024 34.0316H18.1923C18.6022 34.0316 18.9955 33.8688 19.2854 33.5789C19.5752 33.289 19.7381 32.8958 19.7381 32.4859C19.7381 32.0759 19.5752 31.6829 19.2854 31.393C18.9955 31.1031 18.6022 30.9402 18.1923 30.9402H13.0405V27.2184C15.7525 26.8516 18.2394 25.5139 20.0404 23.4533C21.8414 21.3928 22.8342 18.749 22.8347 16.0123Z"
          fill={color}
        />
      </svg>
    </SvgIcon>
  );
}
